import { styled } from '@/stitches.config';
import { Box, Link } from '@base-app';
import { ReactComponent as ExpandingButton } from '@assets/icons/expanding-button.svg';
import { ReactComponent as HelixLogomark } from '@assets/helix-logomark.svg';
import { ReactComponent as HelixBuilderLogo } from '@assets/helix-builder-logo.svg';

export const SidebarContainerStyled = styled(Box, {
  backgroundColor: '$seafoam600',
  boxShadow: '$sidebar',
  display: 'flex',
  float: 'left',
  flexDirection: 'column',
  height: '100%',
  position: 'fixed',
  transition: 'width 200ms cubic-bezier(0.2, 0, 0, 1) 0s;',
  width: '$studyInsights$sidebarWidthClose',
  zIndex: '$sidebar',
  variants: {
    isOpen: {
      true: {
        width: '$studyInsights$sidebarWidthOpen',
      },
    },
  },
});

export const SidebarContentStyled = styled(Box, {
  height: '100%',
});

export const MenuItemContainerStyled = styled(Box, {
  marginTop: '$18',
});

export const LinkStyled = styled(Link, {
  display: 'flex',
});

export const HelixLogomarkStyled = styled(HelixLogomark, {
  marginRight: '$2',
});

export const SidebarLogoContainerStyled = styled(Box, {
  alignSelf: 'flex-start',
  display: 'flex',
  margin: '$8 $6 $4',
  width: '85%',
});

export const HelixBuilderLogoStyled = styled(HelixBuilderLogo, {
  opacity: 0,
  transition: 'opacity 1ms ease',
  variants: {
    isOpen: {
      true: {
        transition: 'opacity 0.5s ease',
        opacity: 1,
      },
    },
  },
});

export const ExpandingButtonContainerStyled = styled(Box, {
  alignSelf: 'flex-end',
  marginRight: '-$3',
  marginTop: '$24',
  position: 'fixed',
  '&:hover': {
    cursor: 'pointer',
  },
});

export const ExpandingButtonStyled = styled(ExpandingButton, {
  variants: {
    isOpen: {
      false: {
        rotate: '180deg',
      },
    },
  },
});
